






























import { Component, Mixins, Prop } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

// Models
import Field from '@/models/Field'

// Mixins
import FieldMixin from '@/mixins/Field'
import FormMixin from '@/mixins/Form'
import ItemMixin from '@/mixins/Item'
import ErrorsMixin from '@/mixins/Errors'
import ModalMixin from '@/mixins/Modal'

// Components
import ModalWrapper from '@/components/common/ModalWrapper.vue'

@Component({
  components: {
    ModalWrapper
  }
})
export default class CreateItemModal extends Mixins(FieldMixin, FormMixin, ErrorsMixin, ItemMixin, ModalMixin) {
  isFetching: boolean = false
  formFields = []

  @Getter('token') token
  @Getter('locale', { namespace: 'user' }) locale

  get bodyFormFields() {
    return this.formFields.map((field) => ({
      name: field.name,
      value: field.value.toString(),
      title: field.titleId,
      type: field.type
    }))
  }

  validations(field) {
    return field.required ? 'required' : ''
  }

  async mounted() {
    try {
      this.isFetching = true
      const res = await this.$api.items.fetchForm(this.token, this.datas.type)
      this.formFields = res.data.map((field) => new Field(field, this.locale))
    } finally {
      this.isFetching = false
    }
  }

  updateField(field, $event) {
    field.value = $event.value
  }


  async submitForm() {
    if (!this.formValid) {
      return
    }

    try {
      this.formLoading = true
      const payload = {
        categoryId: this.categoryId.toString(),
        identifier: this.identifier,
        type: this.datas.type,
        body: this.bodyFormFields
      }
      const res = await this.$api.items.createItem(this.token, payload)
      this.close()
      // TODO reload
      this.$router.go(0)
      this.$toast.open({
        message: this.$t('item.add.create.notification.success') as string,
        type: 'is-success',
        duration: 5000
      })

    } catch (error) {
      this.displayErrors(error)
    } finally {
      this.formLoading = false
    }
  }
}
